export const calculateDevamsizlik = (answers) => {
  const DIMENSIONS = {
    'Okul ve Yönetim': { min: 1, max: 10 },
    'Öğretmen': { min: 11, max: 16 },
    'Aile': { min: 17, max: 26 },
    'Çevre': { min: 27, max: 30 },
    'Akademik Kaygı': { min: 31, max: 36 },
    'Kişisel Nedenler': { min: 37, max: 45 },
    'Arkadaş Çevresi': { min: 46, max: 51 }
  };

  // 🚀 YENİ: Soruların tam metinlerini formdan buraya taşıyoruz
  const DEVAMSIZLIK_ITEMS = [
    "İhtiyaç duyduğumda okul idaresi izin vermediği için", "Zor dersler aynı günde olduğunda", "Geç kaldığımda okul yöneticileriyle karşılaşmak istemediğim için", "Boş derslerde ve öğle aralarında okulda verimli zaman geçireceğim bir alan/mekan olmadığı için", "Giriş ve çıkış saatleri bana uygun olmadığı için",
    "Kılık kıyafetim uygun olmadığında (saç, sakal, takı, makyaj vb.) okul yönetiminden çekindiğim için", "Okul binası (rampa, asansör vb) fiziksel durumuma uygun olmadığı için", "Okulda günlük ders saati çok fazla olduğu için", "Okulun ilk ya da son haftalarında ders yapılmadığı için", "Okulda yeteneklerimi gösterebileceğim fırsatlar olmadığı için",
    "Öğretmenler aşırı disiplinli davrandığı için", "Bazı dersler çok sıkıcı geçtiği için", "Öğretmenler, benden derslerde yapabileceklerimden daha fazlasını yapmamı bekledikleri için", "Öğretmenler, okulda öğrencilere karşı sürekli küçük düşürücü davranışlarında bulundukları için", "Öğretmenler, öğrenciler arasında ayrımcılık yaptığı için",
    "Öğretmenlerim bana yakınlık göstermediği için", "Diğer öğrenciler dersin işlenmesine engel olduğu için", "Ailem, okula gidip gitmememi umursamadığı için", "Ders araç gerecim olmadığında", "Bazı günler harçlığım olmadığı için",
    "Bazı günler kıyafetlerim bakımsız (kirli, ütüsüz) olduğunda", "Aileme yardımcı olmam gereken günlerde", "Okul dışında bir işte çalışmak zorunda olduğum için", "Aile içinde sorunlarımız olduğu zamanlarda", "Evde misafir olduğu zaman",
    "Bir yakınım vefat ettiğinde", "Evim okula çok uzak olduğu için", "Havanın soğuk ya da yağışlı olduğu günlerde", "Özel kurs ve etütlere daha fazla zaman ayırdığım için", "Okul dışındaki etkinliklere katılmak için",
    "Okul yolu güvenli olmadığı için", "Ertesi günün sınavlarına çalışmak için", "Ödevlerimi yapmadığım günlerde", "Başarısız olduğum derslere katılmak istemediğim için", "Bir üst öğretim kurumunun sınavlarına hazırlanmamda okul dersleri yetersiz kaldığı için",
    "Okulu bitirince iş bulabileceğime inanmadığım için", "Okulumu sevmediğim için", "Hasta olduğum zaman", "Sabahları zamanında uyanamadığımda", "Yorucu geçen bir günden sonraki günü dinlenerek geçirmek istediğim için",
    "Dersin telafisi mümkün olduğunda", "Resmi tatillerden önceki ya da sonraki günlerde", "Bazı günler moralim bozuk olduğu için", "Okuldan kaçmak eğlenceli geldiği için", "Okula gitmesem de sınıfı geçeceğimi bildiğim için",
    "Arkadaşlarıma göre yaşça daha büyük olduğum için", "Okul saatinde, okul dışından arkadaşlarımla görüşmek için", "Arkadaşlarımla okuldan kaçma kararı aldığımızda", "Okulda arkadaşlarım tarafından dışlandığım için", "Okuldaki öğrenciler fiziksel veya duygusal olarak bana zarar verdiği için",
    "Okulda arkadaşlarımla anlaşamadığım için"
  ];

  let scores = {};
  let maxDim = "";
  let maxVal = -1;
  let detailedRisks = []; // 🚀 YENİ: Öğrencinin "Evet" dediği maddeleri toplayacağımız liste

  Object.keys(DIMENSIONS).forEach(dim => {
    let total = 0, count = 0;
    for (let i = DIMENSIONS[dim].min; i <= DIMENSIONS[dim].max; i++) {
      const val = parseInt(answers[i] || 0); // 3: Evet, 2: Bazen, 1: Hayır

      // 🚀 YENİ: Öğrenci "Evet" (3) seçeneğini işaretlediyse risk listesine ekle
      if (val === 3) {
          detailedRisks.push({
              id: i,
              text: DEVAMSIZLIK_ITEMS[i - 1], // Dizi 0'dan başladığı için -1 yapıyoruz
              category: dim
          });
      }

      total += val;
      count++;
    }
    const avg = total / count; 
    scores[dim] = parseFloat(avg.toFixed(2));
    
    if (avg > maxVal) { maxVal = avg; maxDim = dim; }
  });

  let recs = "Genel devamsızlık takibi.";
  if (maxDim === 'Okul ve Yönetim') recs = "Sonuçlar raporlanarak okul yönetimine bildirilmeli.";
  else if (maxDim === 'Öğretmen') recs = "Öğretmen iletişim becerileri ve sınıf yönetimi çalışmaları.";
  else if (maxDim === 'Aile') recs = "Aile içi iletişim ve ebeveynlik becerileri semineri.";
  else if (maxDim === 'Akademik Kaygı') recs = "Verimli ders çalışma ve hedef belirleme çalışmaları.";
  else if (maxDim === 'Arkadaş Çevresi') recs = "Akran zorbalığı ve hayır diyebilme becerileri.";

  // Eski skalada max 2 iken, yeni (1-3) skalada max 3 olduğu için puanlama matematiğini güncelledik
  const riskScore = Math.max(0, Math.round(((maxVal - 1) / 2) * 100)); 
  const masterRisk = maxVal >= 2.5 ? "high" : (maxVal > 1.5 ? "medium" : "low");

  return {
    riskScore: riskScore,
    masterRisk: masterRisk, 
    isCritical: false, 
    domain: "behavioral", 

    summary: `BASKIN NEDEN: ${maxDim.toUpperCase()}`,
    analysis: `Devamsızlığın ana kaynağı '${maxDim}' boyutu olarak görünmektedir.`,
    chartData: Object.keys(scores).map(key => ({ 
      subject: key, 
      A: scores[key], 
      fullMark: 3 
    })),
    // 🚀 YENİ: Jenerik uyarı yerine, doğrudan işaretlenen maddeleri gönderiyoruz
    risks: detailedRisks, 
    colorCode: maxVal >= 2.5 ? "red" : "amber",
    recommendations: recs
  };
};